import type {ReactElement} from 'react';
import React, {useEffect} from 'react';
import {ContextualMenuToggleOption} from '@Components/contextual-menu/components/contextual-menu-toggle-option';
import {BaseCurveEdgeEffectThicknessOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-curve-edge-effect-thickness-option';
import {updateOptionsPanelHeight} from '@Components/poster-editor/library/poster-editor-library';

interface BaseImageRoundnessOptionProps {
  isChecked: boolean;
  onToggleCurved(): void;
  edgeThickness: number;
  onUpdateThickness(value: number, undoable?: boolean): void;
  isOpenedInPanel?: boolean;
  panelId?: string;
}

export function BaseImageRoundnessOption({isOpenedInPanel = false, panelId = '', ...props}: BaseImageRoundnessOptionProps): ReactElement<any> {
  useEffect((): void => {
    if (!isOpenedInPanel) {
      return;
    }
    if (props.isChecked) {
      updateOptionsPanelHeight(panelId, '188px');
    } else {
      updateOptionsPanelHeight(panelId, '112px');
    }
  }, [props.isChecked]);

  const getThicknessOption = (): ReactElement<any> | null => {
    return props.isChecked ? (
      <BaseCurveEdgeEffectThicknessOption
        edgeThickness={props.edgeThickness}
        onUpdateThickness={(value, undoable): void => {
          props.onUpdateThickness(value, undoable);
        }}
      />
    ) : null;
  };

  if (isOpenedInPanel) {
    return (
      <>
        {getThicknessOption()}
        <ContextualMenuToggleOption
          className={props.isChecked ? 'spacing-m-t-4' : ''}
          id="item-roundness-option"
          label={window.i18next.t('pmwjs_roundness')}
          isChecked={props.isChecked}
          onClick={(): void => {
            props.onToggleCurved();
          }}
        />
      </>
    );
  }

  return (
    <ContextualMenuToggleOption
      id="item-roundness-option"
      label={window.i18next.t('pmwjs_roundness')}
      isChecked={props.isChecked}
      onClick={(): void => {
        props.onToggleCurved();
      }}
    >
      {getThicknessOption()}
    </ContextualMenuToggleOption>
  );
}
